import "./TimeLine.css"

function EventCard({heading, subHeading}) {
    return (
        <div className={"eventCardContainer"}>
            <h2 className={"heading"}>{heading}</h2>

            {subHeading.split('\n').map((line, index) => (
                 <li key={index} style={{listStyle:"none", display: 'flex', padding: '10px'}}>
                    <i className="fas fa-check-circle list-icon"></i>
                    <p>{line}</p>
                </li>
            ))}

        </div>
    )

}export default EventCard;